export default {
  INIT: 'CUSTOMER/INIT',
  UPDATE_DATA: 'CUSTOMER/UPDATE_DATA',
  UPDATE_META: 'CUSTOMER/UPDATE_META',
  UPDATE_PARAMS: 'CUSTOMER/UPDATE_PARAMS',
  UPDATE_TAGS: 'CUSTOMER/UPDATE_TAGS',
  UPDATE_REFERRER_NAME: 'CUSTOMER/UPDATE_REFERRER_NAME',
}
